<template lang="html">
  <div class="language-selector">
    <h2 class="language-selector__title">
      {{ $t("common.lang.langSelection", "en") }}
    </h2>
    <div class="language-selector__items">
      <a
        v-for="(lang, index) in languages"
        :key="index"
        class="language-selector__item"
        href="#"
        @click.prevent="changeLang(lang)"
      >
        <picture v-if="selected === lang" class="language-selector__status">
          <source
            srcset="@/assets/images/lang-select-checked-dark.svg"
            media="(prefers-color-scheme: dark)"
          />
          <img src="@/assets/images/lang-select-checked.svg" alt="" />
        </picture>
        <picture v-else class="language-selector__status">
          <source
            srcset="@/assets/images/lang-select-unchecked-dark.svg"
            media="(prefers-color-scheme: dark)"
          />
          <img src="@/assets/images/lang-select-unchecked.svg" alt="" />
        </picture>
        <div class="language-selector__flag-and-lang">
          <img
            class="language-selector__flag"
            :src="`${config.imagesPath}/flag-${lang}.svg`"
            alt=""
          />
          <span class="language-selector__language">
            {{ $t("common.lang." + lang) }}
          </span>
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue"
import config from "../../config"
import { useI18n } from "vue-i18n"

const { availableLocales, locale } = useI18n()

const languages = ref(availableLocales)
const selected = ref(locale)

watch(locale, (newValue) => {
  selected.value = newValue
})

const changeLang = (lang: string) => {
  locale.value = lang
  selected.value = lang
}
</script>
